import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getInfoImagesPerName, getAllCarouselSlides, getAboutUsSectionImageUrl, getFirmnessSectionImageUrl, getSizingSectionImageUrl, getDildoSectionImageUrl, getAccessoriesSectionImageUrl, getMerchandiseSectionImageUrl } from '../controllers/HomeConnectionLayer';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import "../style/HomePage.css";
import "../style/AppPages.css";
import CanadaQuebec from '../icon/CanadaQuebec.svg';
import QuebecCanada from '../icon/QuebecCanada.svg';
import { useTranslation } from 'react-i18next';
import { getSelectedLanguageOption } from '../i18n';
import { homeImages } from '../images/siteImages';

import Loading from '../components/Loading';

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const currentLang = getSelectedLanguageOption(i18n.language).value;
  const [loading, setLoading] = useState(true);

  
  const [carouselSlides, setcarouselSlides] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);
  const categorySectionsRef = useRef([]);
  const [hoveredLeft, setHoveredLeft] = useState(false);
  const [hoveredRight, setHoveredRight] = useState(false);

  const [aboutUsImageUrl, setDataAboutUs] = useState([]);
  const [firmnessImageUrl, setDataFirmness] = useState([]);

  const discreetExpeditionImageUrl = homeImages[currentLang.toUpperCase()].discreetExpedition;

  const [dildoImageUrl, setDildoImageUrl] = useState([]);
  // const [plugImageUrl, setPlugImageUrl] = useState([]);
  // const [masturbatorImageUrl, setMasturbatorImageUrl] = useState([]);
  // const [wearableImageUrl, setWearableImageUrl] = useState([]);
  // const [grinderImageUrl, setGrinderImageUrl] = useState([]);
  const [accessoryImageUrl, setAccessoryImageUrl] = useState([]);
  const [merchandiseImageUrl, setMerchandiseImageUrl] = useState([]);

  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const [imagesLoaded, setImagesLoaded] = useState(0);

  const [totalImages, setTotalImages] = useState(0);

  // useEffect(() => {
  //   const fetchDataCarousel = async () => {
  //     const carrouselSlides = await getAllCarouselSlides();
  //     setcarouselSlides(carrouselSlides);
  //   };

  //   const fetchDataAboutUs = async () => {
  //     const dataAboutUs = await getAboutUsSectionImageUrl();
  //     setDataAboutUs(dataAboutUs);
  //   };

  //   const fetchDataFirmness = async () => {
  //     const dataFirmness = await getFirmnessSectionImageUrl();
  //     setDataFirmness(dataFirmness);
  //   };

  //   const fetchCategoriesData = async () => {
  //     const dataDildo = await getDildoSectionImageUrl();
  //     setDildoImageUrl(dataDildo);

  //     const dataAccessories = await getAccessoriesSectionImageUrl();
  //     setAccessoryImageUrl(dataAccessories);

  //     const dataMerchandise = await getMerchandiseSectionImageUrl();
  //     setMerchandiseImageUrl(dataMerchandise);
  //   };


  //   try{
  //     fetchDataCarousel();
  //     fetchDataAboutUs();
  //     fetchDataFirmness();
  //     fetchCategoriesData();
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  //   finally {
  //     setLoading(false);
  //   }
  // }, []);

  useEffect(() => {
    let total = 0;

    // These are your image dependencies
    Promise.all([
      getAllCarouselSlides(),
      getAboutUsSectionImageUrl(),
      getFirmnessSectionImageUrl(),
      getSizingSectionImageUrl(),
      getDildoSectionImageUrl(),
      getAccessoriesSectionImageUrl(),
      getMerchandiseSectionImageUrl(),
    ]).then(([carousel, about, firmness, sizing, dildo, accessories, merch]) => {
      setcarouselSlides(carousel);
      setDataAboutUs(about);
      setDataFirmness(firmness);
      setDildoImageUrl(dildo);
      setAccessoryImageUrl(accessories);
      setMerchandiseImageUrl(merch);

      total = carousel.length + 5; // 1 each for about, firmness, sizing, dildo, accessories, merch
      setTotalImages(total);
    }).catch(console.error);
  }, []);

  useEffect(() => {
    if (imagesLoaded >= totalImages && totalImages > 0) {
      setLoading(false);
    }
  }, [imagesLoaded, totalImages]);

  const handleImageLoad = () => {
    setImagesLoaded(prev => prev + 1);
  };

  const navigate = useNavigate();
  const scrollToSection = (section) => {
    navigate(`/products#${section}`);
    setTimeout(() => {
      const anchor = document.querySelector(`#${section}`);
      if (anchor) {
        const headerOffset = 190;
        const elementPosition = anchor.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 100);
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && hasLoaded) {
          entry.target.classList.add('visible'); // Add the visible class for fade-in
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -25px 0px',
    });

    categorySectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    setHasLoaded(true);

    return () => {
      categorySectionsRef.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, [carouselSlides, hasLoaded]);
  
  const arrowStyleRight = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 30,
    height: 30,
    cursor: 'pointer',
    color: hoveredRight ? 'gray' : 'lightgray',
    right: 15,
    transition: 'color 0.3s ease',
    border: 'none',
    background: 'none',
    outline: 'none',
    fontSize: '24px',
  };

  const arrowStyleLeft = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 30,
    height: 30,
    cursor: 'pointer',
    color: hoveredLeft ? 'gray' : 'lightgray',
    left: 15,
    transition: 'color 0.3s ease',
    border: 'none',
    background: 'none',
    outline: 'none',
    fontSize: '24px',
  };

  const renderArrowPrev = (onClickHandler, hasPrev, label) =>
    hasPrev && (
      <button onClick={onClickHandler} title={label} style={{ ...arrowStyleLeft }} onMouseEnter={() => setHoveredLeft(true)} // Hover start
      onMouseLeave={() => setHoveredLeft(false)}>&#9664;</button>
    );

  const renderArrowNext = (onClickHandler, hasNext, label) =>
    hasNext && (
      <button onClick={onClickHandler} title={label} style={{ ...arrowStyleRight  }} onMouseEnter={() => setHoveredRight(true)} // Hover start
      onMouseLeave={() => setHoveredRight(false)}>&#9654;</button>
    );

    return (
      <>
      <Loading isVisible={loading} />
        <div class="page-padding-home">
          <div class="carousel-container">
            <Carousel
              key={carouselSlides.length}
              useKeyboardArrows={true} 
              swipeable={true} 
              showThumbs={false} 
              showArrows={true} 
              autoPlay={true}
              interval={5000}
              infiniteLoop={true}
              showStatus={false}
              renderArrowPrev={renderArrowPrev}
              renderArrowNext={renderArrowNext}>
              {carouselSlides.map((carouselSlide, index) => (
                <div
                key={index}
                onClick={() => {
                  if (carouselSlide.redirectionUrl) {
                    window.location.href = carouselSlide.redirectionUrl;
                  }
                }}
                style={{ cursor: carouselSlide.redirectionUrl ? 'pointer' : 'default' }}
              >
                <img src={carouselSlide.imageUrl} onLoad={handleImageLoad} alt="Image carousel" />
              </div>
              
              ))}
            </Carousel>
          </div>

          <div class="display-container">
            <div class="horizontal-container">
              <div class="horizontal"></div>
            </div>

            <div className="categories-container">
              <div class="categories-title">{t('home.browseCategories')}</div>
              
              <div className="categories">
                <div class="col-1">
                  <div class="info-section lft"
                    ref={(el) => (categorySectionsRef.current[0] = el)}
                    data-index={1}
                    onClick={() => scrollToSection('dildos')}
                  >
                      <img class="max-width-img" src={i18n.language === 'fr' ? dildoImageUrl.imageUrlFR : dildoImageUrl.imageUrl} alt="Dildo" onLoad={handleImageLoad} />
                  </div>
                  <div class="title-section">{t('categories.dildosCategory')}</div>
                </div>

                <div class="col-1">
                  <div class="info-section lft"
                    ref={(el) => (categorySectionsRef.current[4] = el)}
                    data-index={1}
                    onClick={() => scrollToSection('accessories')}
                  >
                      <img class="max-width-img" src={i18n.language === 'fr' ? accessoryImageUrl.imageUrlFR : accessoryImageUrl.imageUrl} alt="Accessories" onLoad={handleImageLoad} /> 
                  </div>
                  <div class="title-section">{t('categories.accessoriesCategory')}</div>
                </div>

                <div class="col-1">
                  <div class="info-section lft"
                    ref={(el) => (categorySectionsRef.current[5] = el)}
                    data-index={1}
                    onClick={() => scrollToSection('merchandise')}
                  >
                      <img class="max-width-img" src={i18n.language === 'fr' ? merchandiseImageUrl.imageUrlFR : merchandiseImageUrl.imageUrl} alt="Merchandise" onLoad={handleImageLoad} />
                  </div>
                  <div class="title-section">{t('categories.merchandiseCategory')}</div>
                </div>

                {/* <div class="col-double">
                  <div class="col-2">
                    <div class="info-section lft hide-small-mid"
                      ref={(el) => (categorySectionsRef.current[0] = el)}
                      data-index={1}
                      onClick={() => scrollToSection('plugs')}
                    >
                      <img src={firmnessImageUrl} alt={firmnessImageUrl}/>
                      <div class="title-section hover-text">Plugs</div>
                    </div>

                    <div
                      class="info-section lft"
                      ref={(el) => (categorySectionsRef.current[1] = el)}
                      data-index={2}
                      onClick={() => scrollToSection('masturbators')}
                    >
                      <img src={firmnessImageUrl} alt={firmnessImageUrl}/>
                      <div class="title-section hover-text">Masturbators</div>
                    </div>

                    <div
                      class="info-section lft"
                      ref={(el) => (categorySectionsRef.current[2] = el)}
                      data-index={3}
                      onClick={() => scrollToSection('wearables')}
                    >
                      <img src={firmnessImageUrl} alt={firmnessImageUrl}/>
                      <div class="title-section hover-text">Wearables</div>
                    </div>
                  </div>

                  <div class="col-3">
                    <div
                      class="info-section rit"
                      ref={(el) => (categorySectionsRef.current[3] = el)}
                      data-index={4}
                      onClick={() => scrollToSection('grinders')}
                    >
                      <img src={firmnessImageUrl} alt={firmnessImageUrl}/>
                      <div class="title-section hover-text">Grinders</div>
                    </div>

                    <div
                      class="info-section rit"
                      ref={(el) => (categorySectionsRef.current[4] = el)}
                      data-index={5}
                      onClick={() => scrollToSection('accessories')}
                    >
                      <img src={firmnessImageUrl} alt={firmnessImageUrl}/>
                      <div class="title-section hover-text">Accessories</div>
                    </div>

                    <div
                      class="info-section rit"
                      ref={(el) => (categorySectionsRef.current[5] = el)}
                      data-index={6}
                      onClick={() => scrollToSection('merchandise')}
                    >
                      <img src={firmnessImageUrl} alt={firmnessImageUrl}/>
                      <div class="title-section hover-text">Merchandise</div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <div class="horizontal-container">
              <div class="horizontal horizontal-new"></div>
            </div>
            
            <div class="bottom-container">
              <div class="info-section-titre">
                {t('home.needHelpTitle')}
              </div>
            
              {/* <div className="infos-container-row">
                <div className="infos-container-col">
                  <div className="info-section info-section-beans ">
                    <img src={firmnessImageUrl} alt="Firmness guide" />
                  </div>
                  <div className="info-title">Firmness guide</div>
                </div>

                <div className="infos-container-col">
                  <div className="info-section info-section-beans ">
                    <img src={aboutUsImageUrl} alt="Why choose us?" />
                  </div>
                  <div className="info-title">Why choose us?</div>
                </div>
              </div> */}

              <div className="categories">
                <div class="col-2">
                  <div class="info-section lft btm">
                    <img class="max-width-img" src={i18n.language === "fr" ? firmnessImageUrl.imageUrlFR : firmnessImageUrl.imageUrl} alt="Softness guide" onLoad={handleImageLoad} onClick={() => navigate('/softness-guide')}/>
                  </div>
                  <div class="title-section">{t('home.softnessTitle')}</div>
                  <div class="description-section">{t('home.softnessDescription')}</div>
                </div>
                <div class="col-2">
                  <div class="info-section lft btm">
                    <img class="max-width-img" src={i18n.language === "fr" ? aboutUsImageUrl.imageUrlFR : aboutUsImageUrl.imageUrl} alt="Why choose us?" onLoad={handleImageLoad} onClick={() => navigate('/why-choose-us')}/>
                  </div>
                  <div class="title-section">{t('home.whyChooseUsTitle')}</div>
                  <div class="description-section">{t('home.whyChooseUsDescription')}</div>
                </div>
              </div>
            </div>

            <div class="horizontal-container">
              <div class="horizontal horizontal-new"></div>
            </div>

            <div class="image-section-container image-section-padded">
              <div class="image-section">
                <img class="max-width-img" src={discreetExpeditionImageUrl} alt="Discreet Expedition" onLoad={handleImageLoad} />
              </div>
            </div>

            <div class="horizontal-container">
              <div class="horizontal horizontal-new"></div>
            </div>

            <div class="text-container">
              <div class="title-with-icon">
                <div class="text-title">{t('home.aboutUsTitle')}</div>
                <span className="info-tooltip" onClick={() => setIsInfoOpen(v => !v)}>
                  <FontAwesomeIcon icon={faCircleInfo} color="var(--header-lighter-color)" />
                  <span className={`tooltip-bubble ${isInfoOpen ? 'visible' : ''}`}>
                    <ul>
                      <li>{t("product.infoTooltip1")}</li>
                      <li>{t("product.infoTooltip2")}</li>
                    </ul>
                  </span>
                </span>
              </div>

              <p class="text">
                  {t('home.aboutUsText1')}
                  <br />
                  <br />
                  {t('home.aboutUsText2')}
              </p>
            </div>

            <div class="horizontal-container container-bottom">
              <div class="horizontal"></div>
            </div>

            <div class="curved-background-container">
              <img class="curved-container-img" src={CanadaQuebec} alt="Canada and Quebec icon" />
              <div>
                <div class="curved-container-text">{t('home.madeQuebec')}</div>
                <button class="form-button section-button-override" onClick={() => navigate('/products')}>{t("home.viewOurProducts")}</button>
              </div>
              <img class="curved-container-img" src={QuebecCanada} alt="Quebec and Canda icon" />
            </div>

            <div class="horizontal-container container-bottom">
              <div class="horizontal"></div>
            </div>
          </div>
        </div>
      </>
    );
};

export default HomePage;
